import { makeStyles } from "@mui/styles";
import jwt_decode from "jwt-decode";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "src/colors/colors";
import HeaderTitle from "src/commonStyles/text/headerTitle/headerTitle";
import TextTitle from "src/commonStyles/text/textTitle/textTitle";
import StepsPayment from "src/components/homePage/components/steps/steps";
import { FontSize } from "src/const/font";
import DateFns from "src/utils/DateFns";
import resultFail from "../../assets/payment/result-fail.png";
import resultSucess from "../../assets/payment/result-success.png";
import ButtonCommon from "../../commonStyles/button/button";
import { messageTypeFee, nameEformByTypeFee } from "../../const/message";
import { partnerCode } from "../../const/partnerCode";
import { convertTotalAmountToVND } from "../../utils/convert/totalAmount";
import { UpdateStatusPay } from "../../api/updateStatusPay";
import { fromSystem } from "../../const/fromSystem";
import { DatePattend } from "src/utils/DatePattend";
import { codeSuccessPay, cancerPay } from "../../const/codeSuccessPay";
import { PaymentResultSuccess, textButton } from "../../const/index";
import { itemLocalstorage } from "../../const/itemLocalstorage";
import PopupService from "src/utils/PopupService";
import StatusSuccessIcon from "src/assets/status-success-icon.svg";
import BrandButton from "src/assets/brand_button.svg";
import SmsIcon from "src/assets/sms.svg";
import CallIcon from "src/assets/call.svg";
import { FR_SYSTEM_CONFIG_MBAL_APP } from "src/const/const-from-env";
import { handleBackApp } from "../TypePay";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import IconSuccessPopupNotifi from "src/assets/popupNotifi/success.svg";
import ImageStep1 from "src/assets/popupNotifi/image_step1.jpg";
import ImageStep2 from "src/assets/popupNotifi/image_step2.jpg";
import ImageStep3 from "src/assets/popupNotifi/image_step3.jpg";
import ImageStep4 from "src/assets/popupNotifi/image_step4.jpg";
import ImageStep5 from "src/assets/popupNotifi/image_step5.jpg";
import ImageQR from "src/assets/popupNotifi/qr_download.svg";
import { handlePhoneCall } from "src/utils/checkMobileWebView";
//! Type
interface DataParamsI {
  contractNumber: string;
  timePay: string;
  money: string;
  code?: string;
  orderReference?: string;
  contentPay: string;
  typePay: string;
}
interface ParamsInternationalCardI {
  amount: string;
  code: string;
  description: string;
  orderId: string;
}
interface ParamsLocalCardI {
  error_code: string;
  mac: string;
  mac_type: string;
  pg_amount: string;
  pg_card_holder_name: string;
  pg_card_number: string;
  pg_currency: string;
  pg_issuer_code: string;
  pg_issuer_response_code: string;
  pg_issuer_txn_reference: string;
  pg_merchant_id: string;
  pg_order_info: string;
  pg_order_reference: string;
  pg_payment_channel: string;
  pg_payment_method: string;
  pg_transaction_number: string;
  session_id: string;
  orderId: string;
}
interface ParamsMomoI {
  amount: number;
  creditAmount: number;
  encryptedData: string;
  paymentId: string;
  reference1: string;
  reference2: string;
  requestId: string;
  resultCode: number;
}

interface ParamsBaoKimI {
  checksum: string;
  created_at: string;
  env: string;
  id: string;
  mrc_order_id: string;
  stat: string;
  total_amount: string;
  txn_id: string;
  update_at: string;
  version: string;
}

interface ParamsQrGenI {
  orderId: string;
  idNumber: string;
  feeType: string;
  id: string;
  errCode: string;
  paymentAmount: string;
}
const useStyles = makeStyles((theme) => {
  return {
    containerContent: {
      background: colors.white,
    },
    textHeader: {
      fontSize: "36px",
      lineHeight: "48px",
      textAlign: "center",
      padding: "32px 0",
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
        padding: "0",
        marginBottom: "16px",
        fontWeight: 700,
        lineHeight: "26px",
      },
    },
    containerImageStatusPay: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "40px",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "20px",
      },
    },
    item: {
      display: "flex",
      justifyContent: "space-between",
      padding: "28px 0",
      borderBottom: "1px solid #F0F0F0",
      [theme.breakpoints.down("sm")]: {
        padding: "23px 0",
      },
    },
    contentPay: {
      width: "70%",
      margin: "0 auto",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        maxWidth: "500px",
      },
    },
    btn: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: "210px",
      paddingTop: "24px",
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "0px",
      },
    },
    textLeft: {
      color: colors.text.main,
      lineHeight: "24px",
      [theme.breakpoints.down("sm")]: {
        fontSize: FontSize.sub.default,
        lineHeight: "18px",
      },
    },
    textRight: {
      color: colors.text.main,
      lineHeight: "26px",
      fontSize: "20px",
      textAlign: "end",
      width: "50%",
      overflowWrap: "break-word",
      [theme.breakpoints.down("sm")]: {
        fontSize: FontSize.sub.default,
        lineHeight: "18px",
        width: "50%",
      },
    },
    textFee: {
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
  };
});
const statusSuccess = {
  icon: resultSucess,
  text: "Thanh toán thành công",
  status: "SUCCESS",
};
const statusError = {
  icon: resultFail,
  text: "Thanh toán không thành công",
  status: "ERROR",
};
const ResultPay = () => {
  const [statusPay, setStatusPay] = React.useState(statusSuccess);
  const [followedFlow, setFollowedFlow] = React.useState(
    localStorage.getItem("followedFlow")
  );
  const [dataParams, setDataParams] = useState<DataParamsI>();
  const [contractNumber, setContractNumber] = useState<string>("");

  const classes = useStyles();
  const timePay = DateFns.format(new Date(), DatePattend.FullDateTime);
  const params = Object.fromEntries(
    new URLSearchParams(location.search.split("?")[1])
  );
  const navigate = useNavigate();
  const typePay = localStorage.getItem(itemLocalstorage.partnerCode);
  const requestId = localStorage.getItem(itemLocalstorage.paymentId);
  const frSystm = localStorage.getItem(itemLocalstorage.frSystm);

  const renderContentPay = (idContract: string, desc: string) => {
    if (frSystm !== fromSystem.paymentGateway) {
      const orderId = convertOrDerIdToLocal?.description;
      const orderIdConvert = orderId?.slice(0, 19);
      return orderIdConvert;
    } else {
      return `${idContract} ${desc}`;
    }
  };
  const renderContentPayMomo = (idContract: string, desc: string) => {
    if (frSystm !== fromSystem.paymentGateway) {
      const orderId = convertOrDerIdToLocal?.description;
      const orderIdConvert = orderId?.slice(0, 19);
      return orderIdConvert;
    } else {
      return `${idContract}_${desc}`;
    }
  };
  const orderIdGetToLocal: any = localStorage.getItem(
    itemLocalstorage.dataPayment
  );

  const convertOrDerIdToLocal = JSON.parse(orderIdGetToLocal);
  const convertOrderIdDad = convertOrDerIdToLocal?.policy.orderId
    ?.replaceAll("_", ",")
    .split(",");

  const backHome = () => {
    const callbackHome = localStorage.getItem(itemLocalstorage.callbackURL);
    if (
      FR_SYSTEM_CONFIG_MBAL_APP.includes(params?.frSystm) &&
      params?.type === "eform" &&
      statusPay.status === "SUCCESS"
    ) {
      handleBackApp("continue_create_requests", dataParams);
    } else {
      handleBackApp('go_back', null);
      if (callbackHome === "null" || _.isEmpty(callbackHome)) {
        localStorage.clear();
        if (params.frSystm) {
          navigate(`/?frSystm=${params.frSystm}`);
        } else {
          navigate("/");
        }
      } else {
        localStorage.clear();
        window.open(callbackHome, "_self");
      }
    }
    localStorage.clear();
  };
  const updatePay = async () => {
    try {
      const res = await UpdateStatusPay(requestId, frSystm);
      localStorage.setItem("paymentResult", PaymentResultSuccess);
      localStorage.setItem("paymentedId", requestId);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (followedFlow) {
      followedFlowExecute();
    } else {
      const params = Object.fromEntries(
        new URLSearchParams(location.search.split("?")[1])
      );
      if (params.parnerCode === 'UNLIMINT') {
        const newParams = {
          code: params.code,
          orderId: params.orderId,
          amount: params.amount,
          description: params.description
        };
        handleBackApp('backToLAMB', newParams);
      } else {
        const newParams = {
          error_code: params.error_code,
          pg_amount: params.pg_amount,
          pg_order_info: params.pg_order_info
        };
        handleBackApp('backToLAMB', newParams);
      }
    }
  }, []);

  function noneCaseInternationalCard() {
    const params: any = Object.fromEntries(
      new URLSearchParams(location.search.split("?")[1])
    );
    const dataParams: ParamsBaoKimI = params;
    const convertOrderId = dataParams?.mrc_order_id
      ?.replaceAll("_", ",")
      .split(",");
    setContractNumber(convertOrderId[2]);
    if (dataParams.stat === codeSuccessPay.baokim && dataParams.txn_id) {
      setStatusPay(statusSuccess);
      setDataParams({
        contractNumber: convertOrderId[0],
        timePay: timePay,
        money: convertTotalAmountToVND(dataParams?.total_amount),
        contentPay: renderContentPay(convertOrderId[0], "MBTTBK"),
        typePay: messageTypeFee[`${convertOrderId[2]}`],
        code: dataParams?.mrc_order_id,
      });
      updatePay();
    } else {
      // console.log(dataParams?.stat);
      // if (dataParams?.stat !== codeSuccessPay.baokim) {
      //   window.history.go(-2);
      // } else {
      setStatusPay(statusError);
      setDataParams({
        contractNumber: convertOrderId[0],
        timePay: timePay,
        money: convertTotalAmountToVND(dataParams?.total_amount),
        contentPay: renderContentPay(convertOrderId[0], "MBTTBK"),
        typePay: messageTypeFee[`${convertOrderId[2]}`],
      });
      // }
    }
  }

  function caseInternationalCard() {
    const params: any = Object.fromEntries(
      new URLSearchParams(location.search.split("?")[1])
    );
    const dataParams: ParamsInternationalCardI = params;
    const convertOrderId = dataParams?.orderId
      ?.replaceAll("_", ",")
      .split(",");
    setContractNumber(convertOrderId[2]);
    if (dataParams.code === codeSuccessPay.internationalCard) {
      setStatusPay(statusSuccess);
      setDataParams({
        contractNumber: convertOrderId[0],
        timePay: timePay,
        money: convertTotalAmountToVND(dataParams?.amount),
        contentPay: renderContentPay(convertOrderId[0], "MBTTQT"),
        typePay: messageTypeFee[`${convertOrderId[2]}`],
        code: dataParams?.orderId,
      });
      updatePay();
    } else {
      if (dataParams?.code === cancerPay.internationalCard) {
        window.history.go(-2);
      } else {
        setStatusPay(statusError);
        setDataParams({
          contractNumber: convertOrderId[0],
          timePay: timePay,
          money: convertTotalAmountToVND(dataParams?.amount),
          contentPay: renderContentPay(convertOrderId[0], "MBTTQT"),
          typePay: messageTypeFee[`${convertOrderId[2]}`],
        });
      }
    }
  }

  function localCardExe() {
    const params: any = Object.fromEntries(
        new URLSearchParams(location.search.split("?")[1])
      );
      const dataParams: ParamsLocalCardI = params;
      setContractNumber(convertOrderIdDad[2]);
      if (params?.error_code === codeSuccessPay.localCard) {
        setStatusPay(statusSuccess);
        setDataParams({
          contractNumber: convertOrderIdDad[0],
          timePay: timePay,
          money: convertTotalAmountToVND(dataParams?.pg_amount),
          code: dataParams.orderId,
          orderReference: dataParams?.pg_order_reference,
          contentPay: renderContentPay(convertOrderIdDad[0], "MBTTNĐ"),
          typePay: messageTypeFee[`${convertOrderIdDad[2]}`],
        });
        localStorage.setItem(itemLocalstorage.callbackURL, "null");
        updatePay();
      } else {
        if (dataParams?.error_code === cancerPay.localCard) {
          window.history.go(-3);
        } else {
          setStatusPay(statusError);
          setDataParams({
            contractNumber: convertOrderIdDad[0],
            timePay: timePay,
            money: convertTotalAmountToVND(dataParams.pg_amount),
            contentPay: renderContentPay(convertOrderIdDad[0], "MBTTNĐ"),
            typePay: messageTypeFee[`${convertOrderIdDad[2]}`],
          });
        }
      }
    
  }
  function paymentQRGEN() {
    const dataPayment = localStorage.getItem('dataPaymentQrGen') ? JSON.parse(localStorage.getItem('dataPaymentQrGen')) : null;
      const dataParams: ParamsQrGenI = dataPayment;
      setContractNumber(dataParams?.feeType);
      if (dataParams?.errCode === codeSuccessPay.qrgen) {
        setDataParams({
          contractNumber: dataParams?.idNumber,
          timePay: timePay,
          money: convertTotalAmountToVND(dataParams?.paymentAmount),
          code: dataParams.errCode,
          contentPay: renderContentPay(dataParams?.idNumber, ""),
          typePay: messageTypeFee[`${dataParams?.feeType}`],
        });
        updatePay();



      } else {
        if (dataParams?.errCode === cancerPay.localCard) {
          window.history.go(-3);
        } else {
          setStatusPay(statusError);
          setDataParams({
            contractNumber: dataParams?.idNumber,
            timePay: timePay,
            money: convertTotalAmountToVND(dataParams?.paymentAmount),
            contentPay: renderContentPay(dataParams?.idNumber, ""),
            typePay: messageTypeFee[`${dataParams?.feeType}`],
          });
        }
      }

      const callbackUrl = localStorage.getItem(itemLocalstorage.callbackURL);
      const frSystm = localStorage.getItem(itemLocalstorage.frSystm);
      const dataPaymentQrGen = localStorage.getItem('dataPaymentQrGen') ? JSON.parse(localStorage.getItem('dataPaymentQrGen')) : null;


      if (callbackUrl && frSystm === "WKD04" && dataPaymentQrGen) {
        let urlback = addParamToURL(callbackUrl, "status", dataPaymentQrGen?.payment_status);
        urlback = addParamToURL(urlback, "idnumber", dataPaymentQrGen?.idNumber);
        urlback = addParamToURL(urlback, "totalamount", parseInt(dataPaymentQrGen?.paymentAmount));
        window.location.href = urlback;
      }
    
  }

  function momoPayment() {
    const decodedParamMomo: any = params
      // const convertOrderId = decodedParamMomo.orderId?.replaceAll("_", ",")
      //     .split(",");
      const convertOrderId = decodedParamMomo.orderInfo?.split(":");
      if (convertOrderId) {
        // setContractNumber(convertOrderId[2]);
        setContractNumber('P001');
        const convertOrDerIdToLocal = JSON.parse(orderIdGetToLocal);
        const amount = convertOrDerIdToLocal?.policy?.initialPremium?.totalAmt;
        if (decodedParamMomo?.resultCode === codeSuccessPay.momo) {
          setStatusPay({ ...statusSuccess, text: decodedParamMomo?.message ?? statusSuccess.text });
          setDataParams({
            // contractNumber: convertOrderId[0],
            contractNumber: convertOrderId[1],
            timePay: timePay,
            money: convertTotalAmountToVND(decodedParamMomo.amount),
            code: decodedParamMomo?.orderId,
            contentPay: renderContentPayMomo(
              convertOrderId[1],
              // messageTypeFee[convertOrderId[2]]
              messageTypeFee['']
            ),
            // typePay: messageTypeFee[`${convertOrderId[2]}`],
            typePay: messageTypeFee[''],
          });
          if (requestId) {
            updatePay();
          }
        } else {
          setStatusPay({ ...statusError, text: decodedParamMomo?.message ?? statusError.text });
          setDataParams({
            // contractNumber: convertOrderId[0],
            contractNumber: convertOrderId[1],
            timePay: timePay,
            money: convertTotalAmountToVND(decodedParamMomo?.amount),
            contentPay: renderContentPayMomo(
              // convertOrderId[0],
              convertOrderId[1],
              // messageTypeFee[convertOrderId[2]]
              messageTypeFee['']
            ),
            // typePay: messageTypeFee[`${convertOrderId[2]}`],
            typePay: messageTypeFee[''],
          });
        }
      }
    
  }



  function followedFlowExecute() {
    //! case internationalCard
    if (typePay === partnerCode.baokim) {
      noneCaseInternationalCard();
    } else if (typePay === partnerCode.internationalCard) { // Thẻ ghi nợ/ Thẻ tín dụng
      caseInternationalCard();
    }
    //! case localCard
    else if (typePay === partnerCode.localCard) { // Thẻ ATM nội địa / Thanh toán VietQR
      localCardExe();
    }
    // case QRGEN
    else if (typePay === partnerCode.qrGen) {
      paymentQRGEN();
    }
    //! case momo
    else if (typePay === partnerCode?.momo) {
      momoPayment();
    }
    // Thanh toan VIETQR
    else if (typePay === partnerCode?.vietQr) {
      const dataPayment = localStorage.getItem('dataPaymentQrGen') ? JSON.parse(localStorage.getItem('dataPaymentQrGen')) : null;
      const params: ParamsQrGenI = dataPayment;
      setContractNumber(params?.feeType);

      const newParams = {
        contractNumber: params?.idNumber,
        timePay: timePay,
        code: params?.orderId,
        money: convertTotalAmountToVND(params?.paymentAmount),
        contentPay: renderContentPay(params?.idNumber, ""),
        typePay: messageTypeFee[`${params?.feeType}`],
      }

      setStatusPay(statusSuccess);
      setDataParams(newParams);
      localStorage.setItem(itemLocalstorage.callbackURL, "null");

      updatePay();
    }
  }
  function addParamToURL(url, paramName, paramValue) {

    // Kiểm tra xem URL đã chứa tham số chưa
    const separator = url.includes('?') ? '&' : '?';

    // Tạo URL mới với tham số đã được thêm
    const newURL = `${url}${separator}${paramName}=${paramValue}`;

    return newURL;
  }

  //! case momo
  // useEffect(()=>{
  //   if (params) {
  //     const decodedParamMomo: any = params
  //     const convertOrderId = decodedParamMomo.orderId?.replaceAll("_", ",")
  //         .split(",");
  //         if (convertOrderId){
  //           setContractNumber(convertOrderId[2]);
  //           const convertOrDerIdToLocal = JSON.parse(orderIdGetToLocal);
  //           const amount = convertOrDerIdToLocal?.policy?.initialPremium?.totalAmt;
  //           if (decodedParamMomo?.resultCode === codeSuccessPay.momo) {
  //             setStatusPay({...statusSuccess, text:decodedParamMomo?.message ?? statusSuccess.text  });
  //             setDataParams({
  //               contractNumber: convertOrderId[0],
  //               timePay: timePay,
  //               money: convertTotalAmountToVND(decodedParamMomo.amount),
  //               code: decodedParamMomo?.orderId,
  //               contentPay: renderContentPayMomo(
  //                 convertOrderId[0],
  //                 messageTypeFee[convertOrderId[2]]
  //               ),
  //               typePay: messageTypeFee[`${convertOrderId[2]}`],
  //             });
  //             if (requestId) {
  //               updatePay();
  //             }
  //           } else {
  //             setStatusPay({...statusError, text:decodedParamMomo?.message ?? statusError.text  });
  //             setDataParams({
  //               contractNumber: convertOrderId[0],
  //               timePay: timePay,
  //               money: convertTotalAmountToVND(decodedParamMomo?.amount),
  //               contentPay: renderContentPayMomo(
  //                 convertOrderId[0],
  //                 messageTypeFee[convertOrderId[2]]
  //               ),
  //               typePay: messageTypeFee[`${convertOrderId[2]}`],
  //             });
  //           }
  //         }
  //   }
  // }, [])

  const handleDownload = () => {
    window.open("https://onelink.to/p5eq6a", "_blank", "noopener,noreferrer");
  }

  const NotifiWebContent = (props: { typePay: string }) => (
    <div className="mt-4 md:text-base text-sm">
      <div className="grid grid-cols-1 gap-1 mb-4 md:grid-cols-2 md:gap-4">
        <div>Số tiền thanh toán : <span className="font-bold text-[#DD0071]">{dataParams?.money?.replaceAll(',', '.')}</span></div>
        <div>Tên giao dịch: <span className="capitalize font-bold text-[#22313F]">{nameEformByTypeFee[`${props.typePay}`]}</span> </div>
        <div>Tên hợp đồng : <span className="capitalize font-bold text-[#22313F]">{convertOrDerIdToLocal?.policy?.prdName ?? ''}</span></div>
        <div>Số hợp đồng : <span className="capitalize font-bold text-[#22313F]">{dataParams?.contractNumber}</span></div>
      </div>
      <div className="mb-5">
        <p>Để hoàn tất yêu cầu, Quý khách vui lòng thực hiện các bước sau:</p>
      </div>
      <div className="hidden md:grid-cols-5 md:grid">
        <div className="flex items-center flex-col text-center">
          <div className="flex items-center justify-center text-center mb-4">
            <div className="w-9"></div>
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 1
            </div>
            <div className="ml-1 border-2 border-[#DD00711A] w-10"></div>
          </div>
          <div className="mb-4 text-sm">
            Tải và truy cập ứng dụng <span className="font-semibold text-[#DD007199]">MBAL Style</span>
          </div>
          <img className="hover:cursor-pointer" src={ImageQR} onClick={() => handleDownload()} />
          <div className="mb-4 text-sm">
            Vui lòng quét mã để tải ứng dụng <span className="font-semibold text-[#DD007199]">MBAL Style</span>
          </div>
        </div>
        <div className="flex items-center flex-col text-center">
          <div className="flex items-center justify-center text-center mb-4">
            <div className="mr-1 border-2 border-[#DD00711A] w-11"></div>
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 2
            </div>
            <div className="ml-1 border-2 border-[#DD00711A] w-11"></div>
          </div>
          <div className="mb-4 text-sm">
            <p>
              Chọn
            </p> <span className="font-semibold text-[#DD007199]">Điều chỉnh hợp đồng</span>, Thực hiện quy trình <span className="font-semibold text-[#DD007199]">đăng nhập</span>
          </div>

        </div>
        <div className="flex items-center flex-col text-center">
          <div className="flex items-center justify-center text-center mb-4">
            <div className="mr-1 border-2 border-[#DD00711A] w-11"></div>
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 3
            </div>
            <div className="ml-1 border-2 border-[#DD00711A] w-11"></div>
          </div>
          <div className="mb-4 text-sm">
            Chọn <span className="font-semibold text-[#DD007199]">Tạo mới yêu cầu</span>
          </div>
        </div>
        <div className="flex items-center flex-col text-center">
          <div className="flex items-center justify-center text-center mb-4">
            <div className="mr-1 border-2 border-[#DD00711A] w-11"></div>
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 4
            </div>
            <div className="ml-1 border-2 border-[#DD00711A] w-11"></div>
          </div>
          <div className="mb-4 text-sm">
            Chọn <span className="font-semibold text-[#DD007199]">{nameEformByTypeFee[`${props.typePay}`]}</span>
          </div>
        </div>
        <div className="flex items-center flex-col text-center">
          <div className="flex items-center justify-center text-center mb-4">
            <div className="mr-1 border-2 border-[#DD00711A] w-11"></div>
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 5
            </div>
            <div className="w-9"></div>
          </div>
          <div className="mb-4 text-sm">
            Nhập nội dung và xác nhận yêu cầu trên ứng dụng
          </div>

        </div>
      </div>
      <div className="grid grid-cols-1 md:hidden">
        <div className="flex items-baseline flex-row text-left">
          <div className="flex items-center justify-center text-center mr-5 flex-col">
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 1
            </div>
            <div className="my-2 ml-1 border-2 border-[#DD00711A] h-28"></div>
          </div>
          <div className="flex flex-col items-baseline justify-center text-left">
            <div className="mb-4 text-sm">
              Tải và truy cập ứng dụng <span className="font-semibold text-[#DD007199]">MBAL Style</span>
            </div>
            <div className="flex flex-row items-center justify-center text-left">
              <img className="hover:cursor-pointer" src={ImageQR} onClick={() => handleDownload()} />
              <div className="ml-2 text-sm">
                Vui lòng quét mã để tải ứng dụng <span className="font-semibold text-[#DD007199]">MBAL Style</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-baseline flex-row text-left">
          <div className="flex items-center justify-center text-center mr-5 flex-col">
            <div className="mr-1 border-2 border-[#DD00711A] w-11 hidden"></div>
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 2
            </div>
            <div className="my-2 ml-1 border-2 border-[#DD00711A] h-14"></div>
          </div>
          <div className="mb-4 text-sm">
            <p>
              Chọn <span className="font-semibold text-[#DD007199]">Điều chỉnh hợp đồng</span>, Thực hiện quy trình <span className="font-semibold text-[#DD007199]">đăng nhập</span>
            </p>
          </div>

        </div>
        <div className="flex items-baseline flex-row text-left">
          <div className="flex items-center justify-center text-center mr-5 flex-col">
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 3
            </div>
            <div className="my-2 ml-1 border-2 border-[#DD00711A] h-14"></div>
          </div>
          <div className="mb-4 text-sm">
            Chọn <span className="font-semibold text-[#DD007199]">Tạo mới yêu cầu</span>
          </div>
        </div>
        <div className="flex items-baseline flex-row text-left">
          <div className="flex items-center justify-center text-center mr-5 flex-col">
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 4
            </div>
            <div className="my-2 ml-1 border-2 border-[#DD00711A] h-14"></div>
          </div>
          <div className="mb-4 text-sm">
            Chọn <span className="font-semibold text-[#DD007199]">{nameEformByTypeFee[`${props.typePay}`]}</span>
          </div>
        </div>
        <div className="flex items-baseline flex-row text-left">
          <div className="flex items-center justify-center text-center mr-5 flex-col">
            <div className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] text-[#DD007199] w-[68px] h-[32px] font-medium flex justify-center items-center">
              Bước 5
            </div>
          </div>
          <div className="mb-4 text-sm">
            Nhập nội dung và xác nhận yêu cầu trên ứng dụng
          </div>

        </div>
      </div>
      <div className="mt-4 text-sm">
        {
          props.typePay !== "P004" ?
            <p>Nếu Quý khách không nộp yêu cầu, số tiền đã thanh toán được tự động phân bổ và khấu trừ cho kỳ phí bảo hiểm đến hạn tiếp theo.</p>
            :
            <p>Nếu Quý khách không nộp yêu cầu, chúng tôi rất tiếc chưa thể thực hiện khôi phục hiệu lực hợp đồng này.</p>
        }
      </div>
      <div className="mt-4 text-sm">
        <p>Quý khách có thể liên hệ tới đây để được trợ giúp: <p />
          <p className="bg-[url('src/assets/call.svg')] bg-left bg-no-repeat pl-5 font-semibold text-[#DD0071] mt-2"> 024 2229 8888</p>
          <p className="bg-[url('src/assets/sms.svg')] bg-left bg-no-repeat pl-5 font-semibold text-[#DD0071] mt-2">dvkh@mblife.vn</p>
        </p>
      </div>
    </div>
  );


  const NotifiMobileContent = (props: { typePay: string }) => (
    <div className="text-xs">
      <p className="mt-2">
        Giao dịch thanh toán{" "}
        <strong className="text-[#DD007199]">{dataParams?.money?.replaceAll(',', '.')}</strong> cho phí{" "}
        <strong className="text-[#DD007199]">{nameEformByTypeFee[`${props.typePay}`]}</strong> của hợp đồng
        <strong className="text-[#DD007199] ml-1">
          {convertOrDerIdToLocal?.policy?.prdName ?? ''} - {dataParams?.contractNumber}
        </strong>{" "}
        đã được thực hiện thành công.
      </p>{" "}
      <br />
      <p>
        Để hoàn tất yêu cầu, Quý khách vui lòng thực hiện các bước sau:
      </p>{" "}
      <br />
      <ul>
        <li className="mb-6">
          <span className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] px-2 py-1 text-[#DD007199] mr-5 font-medium">
            Bước 1
          </span>
          Vào trang chủ
        </li>
        <li className="mb-6">
          <span className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] px-2 py-1 text-[#DD007199] mr-5 font-medium">
            Bước 2
          </span>
          Chọn <strong>"Điều chỉnh hợp đồng"</strong>
        </li>
        <li className="mb-6 flex items-center">
          <span className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] px-2 py-1 text-[#DD007199] mr-5 font-medium">
            Bước 3
          </span>
          Chọn <img src={BrandButton} className="mx-[5px]" /> để{" "}
          <strong className="ml-1">"Tạo yêu cầu"</strong>
        </li>
        <li className="mb-6">
          <span className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] px-2 py-1 text-[#DD007199] mr-5 font-medium">
            Bước 4
          </span>
          Chọn <strong>"{nameEformByTypeFee[`${props.typePay}`]}"</strong>
        </li>
        <li className="mb-6">
          <span className="bg-[#DD00711A] rounded-2xl border-[#DD00711A] px-2 py-1 text-[#DD007199] mr-5 font-medium">
            Bước 5
          </span>
          Nộp yêu cầu
        </li>
      </ul>
      {
        props.typePay !== "P004" ?
          <p>Nếu Quý khách không nộp yêu cầu, số tiền đã thanh toán được tự động phân bổ và khấu trừ cho kỳ phí bảo hiểm đến hạn tiếp theo.</p>
          :
          <p>Nếu Quý khách không nộp yêu cầu, chúng tôi rất tiếc chưa thể thực hiện khôi phục hiệu lực hợp đồng này.</p>
      }{" "}
      <br />
      <p>Quý khách có thể liên hệ tới đây để được trợ giúp:</p>
      <a
        className="flex items-center justify-start mt-3 h-[18px] text-[#DD0071] font-semibold cursor-pointer"
        href={`tel:024 2229 8888`}
        onClick={(e) => {
          e.preventDefault();
          handlePhoneCall('024 2229 8888');
        }}
      >
        <img className="mr-2 h-[18px]" src={CallIcon} /> 024 2229 8888
      </a>
      <a
        className="flex items-center justify-start mt-3 h-[18px] text-[#DD0071] font-semibold"
        href={`mailto:dvkh@mblife.vn`}
      >
        <img className="mr-2 h-[18px]" src={SmsIcon} /> dvkh@mblife.vn
      </a>
    </div>
  );

  useEffect(() => {
    const typePay = dataParams?.code?.replaceAll("_", ",").split(",")[2];
    if (!FR_SYSTEM_CONFIG_MBAL_APP.includes(params?.frSystm)) {
      if (statusPay.status === "SUCCESS" && typePay && ['P003', 'P004', 'P005', 'P006'].includes(typePay)) {
        PopupService.instance.current.open({
          visible: true,
          title: "Giao dịch thanh toán đã được thực hiện thành công!",
          children: <NotifiWebContent typePay={typePay} />,
          icon: IconSuccessPopupNotifi,
          classIcon: 'w-10 h-10',
          isHtmlContent: true,
          redConfirm: true,
          showIconClose: true,
          isWebsite: true,
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      }
      return;
    }
    if (
      params?.type !== "eform" &&
      statusPay.status === "SUCCESS" &&
      typePay && ['P003', 'P004', 'P005', 'P006'].includes(typePay)
    ) {
      PopupService.instance.current.open({
        visible: true,
        title: "Thông báo",
        children: <NotifiMobileContent typePay={typePay} />,
        icon: StatusSuccessIcon,
        isHtmlContent: true,
        redConfirm: true,
        showIconClose: true,
        // okTitle: 'Nộp yêu cầu',
        // onOk: () => {
        //   PopupService.instance.current.close();
        //   handleBackApp('create_requests', dataParams)
        // },
        onCancel: () => {
          PopupService.instance.current.close();
        },
      });
    }
  }, [dataParams, statusPay]);

  const handleBackTypePay = () => {
    const url = '/type-pay' + (params?.frSystm ? `?frSystm=${params?.frSystm}` : '') + (params?.frSystm && params?.type ? `&type=${params?.type}` : '') + (params?.frSystm && requestId ? `&paymentId=${requestId}` : '')
    navigate(url);
  }

  return (
    <>
      {dataParams && (followedFlow || params.data) ? (
        <div>
          <HeaderTitle className={classes.textFee}>
            Đóng phí bảo hiểm
          </HeaderTitle>
          <StepsPayment step={3} />
          <div className={classes.containerContent}>
            <div className="flex items-center justify-center">
              {/* {FR_SYSTEM_CONFIG_MBAL_APP.includes(params?.frSystm) && statusPay.status === 'ERROR' &&
              <div onClick={() => handleBackTypePay()} className="mr-3 mb-4">
                <ArrowBackIosIcon/>
              </div>
            } */}
              <TextTitle className={classes.textHeader}>
                {statusPay.text}
              </TextTitle>
            </div>
            <div className={classes.containerImageStatusPay}>
              <img src={statusPay.icon} alt="" />
            </div>
            <div className={classes.contentPay}>
              {dataParams?.contractNumber && (
                <div className={`${classes.item}`}>
                  <div className={classes.textLeft}>
                    {contractNumber === "P001"
                      ? "Mã hồ sơ yêu cầu bảo hiểm"
                      : "Số hợp đồng bảo hiểm"}
                  </div>
                  <div
                    className={classes.textRight}
                    style={{ fontWeight: 600 }}
                  >
                    {dataParams?.contractNumber}
                  </div>
                </div>
              )}
              {dataParams?.timePay && (
                <div className={`${classes.item}`}>
                  <div className={classes.textLeft}>Thời gian thanh toán</div>
                  <div className={classes.textRight}>{dataParams?.timePay}</div>
                </div>
              )}
              {dataParams?.money && (
                <div className={`${classes.item}`}>
                  <div className={classes.textLeft}>Số tiền</div>
                  <div className={classes.textRight}>{dataParams?.money}</div>
                </div>
              )}
              {dataParams?.orderReference && (
                <div className={`${classes.item}`}>
                  <div className={classes.textLeft}>Mã đơn hàng</div>
                  <div className={classes.textRight}>{dataParams?.orderReference}</div>
                </div>
              )}
              {dataParams?.contentPay && (
                <div className={`${classes.item}`}>
                  <div className={classes.textLeft}>Nội dung thanh toán</div>
                  <div className={classes.textRight}>
                    {dataParams?.contentPay}
                  </div>
                </div>
              )}
              {dataParams?.typePay && (
                <div className={`${classes.item}`} style={{ border: "none" }}>
                  <div className={classes.textLeft}>Loại giao dịch</div>
                  <div
                    className={classes.textRight}
                    style={{ textTransform: "capitalize" }}
                  >
                    {dataParams?.typePay}
                  </div>
                </div>
              )}
            </div>
            <div className={`${classes.btn} flex-col md:flex-row content-center`}>
              {FR_SYSTEM_CONFIG_MBAL_APP.includes(params?.frSystm) && statusPay.status === 'ERROR' &&
                <div className="mb-2 md:mb-0 md:mr-6 flex justify-center">
                  <ButtonCommon onEvent={() => handleBackTypePay()}>
                    Quay lại
                  </ButtonCommon>
                </div>
              }
              <div className="mb-2 md:mb-0 md:mr-6 flex justify-center">
                <ButtonCommon onEvent={() => backHome()}>
                  {FR_SYSTEM_CONFIG_MBAL_APP.includes(params?.frSystm) && params?.type === "eform" && statusPay.status === "SUCCESS"
                    ? textButton.backApp
                    : textButton.backHome}
                </ButtonCommon>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            minHeight: "50vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            fontSize: "28px",
          }}
        >
          Đã hoàn thành thanh toán. Hãy xem kết quả trên máy tính của bạn.
        </div>
      )}
    </>
  );
};

export default ResultPay;
